import { render, staticRenderFns } from "./otherOptionDetail.vue?vue&type=template&id=04f31514&scoped=true&"
import script from "./otherOptionDetail.vue?vue&type=script&lang=ts&"
export * from "./otherOptionDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f31514",
  null
  
)

export default component.exports